<script setup>
import { useAuthStore } from "~/stores/auth";
import { useTransition } from "@vueuse/core";

const authStore = useAuthStore();

const amountBalance = useTransition(authStore.balanceAmount, {
  duration: 1500,
  transition: [0.75, 0, 0.25, 1],
});

const realBalance = useTransition(authStore.balance.value, {
  duration: 1500,
  transition: [0.75, 0, 0.25, 1],
});

const bonusBalance = useTransition(authStore.balance.bonus / 100, {
  duration: 1500,
  transition: [0.75, 0, 0.25, 1],
});
</script>

<template>
  <div class="flex flex-1 flex-col space-y-4">
    <div class="flex flex-1 justify-between">
      <div class="flex items-center gap-2 text-xs">
        <span
          class="flex h-5 w-5 items-center justify-center rounded-full bg-green-900 p-2 text-[8px] text-white/90"
          >R$</span
        >
        <b class="leading-none">BRL</b>
      </div>

      <div class="text-base font-semibold">
        {{ money(amountBalance) }}
      </div>
    </div>

    <div class="space-y-2">
      <div class="flex justify-between text-xs">
        <span>Saldo da conta</span>
        <span class="text-gray-500">{{ money(realBalance) }}</span>
      </div>

      <div class="flex justify-between text-xs">
        <span>Dinheiro de bônus</span>
        <span class="text-gray-500">{{ money(bonusBalance) }}</span>
      </div>

      <div class="flex justify-between text-xs">
        <span>Valor máximo de ganho</span>
        <span class="text-gray-500">{{
          money(authStore?.activeRollover?.rollover?.max_amount / 100)
        }}</span>
      </div>
    </div>

    <RolloverProgressBar
      :max-amount="authStore?.activeRollover?.amount_rollover_total / 100"
      :actual-amount="authStore?.activeRollover?.amount_rollover / 100"
    />
  </div>
</template>

<style scoped></style>
